<div class="loadingGif">
  <img src="../../../assets/img/toj.png" alt="loading"/>
  <div>
    <div></div>
  </div>
</div>
